export interface GoogleFont {
  family: string;
  variants: string[];
}

const POPULAR_FONTS: GoogleFont[] = [
  { family: 'Noto Sans JP', variants: ['100', '300', '400', '500', '700', '900'] },
  { family: 'Noto Serif JP', variants: ['200', '300', '400', '500', '600', '700', '900'] },
  { family: 'M PLUS 1p', variants: ['100', '300', '400', '500', '700', '800', '900'] },
  { family: 'M PLUS Rounded 1c', variants: ['100', '300', '400', '500', '700', '800', '900'] },
  { family: 'Kosugi Maru', variants: ['400'] },
  { family: 'Kosugi', variants: ['400'] },
  { family: 'Sawarabi Gothic', variants: ['400', '700'] },
  { family: 'Sawarabi Mincho', variants: ['400', '700'] },
  { family: 'Zen Kaku Gothic New', variants: ['300', '400', '500', '700', '900'] },
  { family: 'Zen Maru Gothic', variants: ['300', '400', '500', '700', '900'] },
  { family: 'Zen Old Mincho', variants: ['400', '500', '600', '700', '900'] },
  { family: 'Kiwi Maru', variants: ['300', '400', '500'] },
  { family: 'Shippori Mincho', variants: ['400', '500', '600', '700', '800'] },
  { family: 'Shippori Gothic', variants: ['400', '500', '600', '700', '800'] },
  { family: 'BIZ UDPGothic', variants: ['400', '700'] },
  { family: 'BIZ UDPMincho', variants: ['400', '700'] },
  { family: 'Reggae One', variants: ['400'] },
  { family: 'RocknRoll One', variants: ['400'] },
  { family: 'Yuji Syuku', variants: ['400'] },
  { family: 'Yuji Boku', variants: ['400'] },
  { family: 'Yuji Mai', variants: ['400'] },
  { family: 'Yuji Syuku', variants: ['400'] },
];

export async function fetchGoogleFonts(): Promise<GoogleFont[]> {
  return POPULAR_FONTS;
}

export function getGoogleFontCSSUrl(fontFamily: string, variants: string[] = ['400']): string {
  const variantsParam = variants.join(',');
  return `https://fonts.googleapis.com/css2?family=${encodeURIComponent(fontFamily)}:wght@${variantsParam}&display=swap`;
}

export async function loadGoogleFont(fontFamily: string): Promise<void> {
  const cssUrl = getGoogleFontCSSUrl(fontFamily);
  
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = cssUrl;
  document.head.appendChild(link);

  await new Promise<void>((resolve, reject) => {
    link.onload = () => resolve();
    link.onerror = () => reject(new Error(`Failed to load font: ${fontFamily}`));
  });

  await document.fonts.load(`16px "${fontFamily}"`);
  await document.fonts.ready;
}
